import { render, staticRenderFns } from "./Portafolio.vue?vue&type=template&id=7864cbb4&"
import script from "./Portafolio.vue?vue&type=script&lang=js&"
export * from "./Portafolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports